import { userRoles } from "../utils/constant";
import useAccountQuery from "./useAccountQuery";
import useIsRole from "./useIsRole";
import useLocationHook from "./useLocationHook";

export const useIsWaiterRole = () => {
  const { data: account } = useAccountQuery();
  return useIsRole(account?.roles, [userRoles.ROLE_WAITER]);
};

const useIsWaiter = () => {
  const isWaiterRole = useIsWaiterRole();
  const { isWaiterPage } = useLocationHook();
  return isWaiterRole || isWaiterPage;
};

export default useIsWaiter;
